// packages/observability/src/index.ts
export { logger, createServiceLogger } from "./logger";
export { setWorkspaceContext, getWorkspaceContext } from "./baggage";
export {
  withSpan,
  tracedFetch,
  tracedHandler,
  recordIncident,
  markActiveSpanError,
} from "./spans";
export { getActiveTraceContext } from "./correlation";
export { AttentionOnlySpanProcessor } from "./sampling-span-processor";
export {
  BaggageEnrichingSpanProcessor,
  BaggageEnrichingLogRecordProcessor,
} from "./baggage-enrichment";
export {
  recordServerError,
  recordServerResponse,
  normalizeHttpRoute,
  flushServerMetrics,
  getServerMetricReader,
  ATTR_HTTP_SERVER_ERRORS,
  ATTR_HTTP_SERVER_REQUESTS,
  ATTR_HTTP_SERVER_DURATION,
  ATTR_VOIP_INBOX_READY_COUNT,
  ATTR_VOIP_INBOX_OLDEST_AGE,
  ATTR_VOIP_EFFECTS_READY_COUNT,
  ATTR_VOIP_EFFECTS_OLDEST_AGE,
  ATTR_VOIP_EFFECTS_FAILED_COUNT,
  ATTR_VOIP_DLQ_UNRESOLVED_COUNT,
  ATTR_VOIP_WEBHOOK_ACK_DURATION,
  ATTR_VOIP_WEBHOOK_ACK_REQUESTS,
  ATTR_VOIP_INBOX_CLAIM_DURATION,
  ATTR_VOIP_REDUCER_APPLY_DURATION,
  ATTR_VOIP_REDUCER_VERSION_CONFLICTS,
  ATTR_VOIP_LEASE_EXPIRED,
  ATTR_VOIP_LEASE_FENCE_REJECTED,
  ATTR_VOIP_EFFECTS_RETRIES,
  ATTR_VOIP_EFFECTS_TERMINAL_FAILURES,
  ATTR_VOIP_COMMAND_RECONCILIATION,
  ATTR_VOIP_DLQ_INSERTED,
  recordVoipQueueHealth,
  recordVoipDurableQueueHealth,
  recordVoipMessageDispatchHealth,
  recordVoipWebhookAck,
  recordVoipOperationDuration,
  recordVoipReliabilityEvent,
  recordVoipCommandReconciliation,
} from "./metrics";
export type { Logger, ServiceLogger } from "./logger";
export type { ServerErrorAttrs } from "./metrics";
export type { ServerResponseAttrs } from "./metrics";
export type { VoipQueueHealth } from "./metrics";
export type { VoipDurableQueueHealth } from "./metrics";
export type { VoipReliabilityEvent } from "./metrics";
export type { WorkspaceContext } from "./baggage";
export type { WithSpanOptions } from "./spans";
export type { TraceContext } from "./correlation";
export type { AttentionOnlySpanProcessorOptions } from "./sampling-span-processor";
